import { ScreenContainer } from "./ScreenContainer";
import { ScreenFooter } from "./ScreenFooter";
import { ScreenHeader } from "./ScreenHeader";
import { ScreenRoot } from "./ScreenRoot";

export const Screen = {
  Root: ScreenRoot,
  Header: ScreenHeader,
  Container: ScreenContainer,
  Footer: ScreenFooter,
};
